import styled from 'styled-components'

export const PrivacyHeadline = styled.h1`
    margin-bottom: 30px;
`

export const PrivacySubHeadline = styled.h2`
    font-size: 1.7rem;
    margin: 0 0 20px;
`

export const PrivacySubSubHeadline = styled.h2`
    font-size: 1.5rem;
    margin: 0 0 10px;
`

export const PrivacySubHeadlineText = styled.span`
    font-weight: bold;
    font-size: 0.9rem;
`

export const PrivacyTextWrapper = styled.div`
    padding: 20px;
    word-wrap: break-word;
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Pages/Privacy.js